import { render, staticRenderFns } from "./TransferMainForm.vue?vue&type=template&id=525c2f30&"
import script from "./TransferMainForm.vue?vue&type=script&lang=js&"
export * from "./TransferMainForm.vue?vue&type=script&lang=js&"
import style0 from "./TransferMainForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports